import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import { Field } from 'react-final-form';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import i18n from 'i18n';
import { applyStyles } from 'util/helpers';
import SelectContainer from './components/SelectContainer';
import CustomMedia from 'util/custom-media-query';
import Tag from 'components/common/Tag';

const SelectBoxField = ({
  className,
  name,
  label,
  validate,
  required,
  ...inputProps
}) => (
  <div className={className}>
    <Field
      name={name}
      validate={v =>
        validate ? validate(!!v && v.value != null ? v.value : v) : null
      }
      render={({ input, meta }) => (
        <React.Fragment>
          {label && (
            <label htmlFor={name}>
              <span>{label}</span>
              {required && <Tag>{i18n.t('common:required')}</Tag>}
            </label>
          )}
          <SelectContainer input={input} meta={meta} inputProps={inputProps} />
        </React.Fragment>
      )}
    />
  </div>
);

SelectBoxField.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  validate: PropTypes.func,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.array.isRequired,
  notes: PropTypes.arrayOf(PropTypes.string)
};

const commonStyle = css`
  label {
    ${FontStyles.text5}

    display: flex;
    color: ${Colors.black1};
    align-items: center;

    span {
      display: block;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  margin: 40px 0;
  label {
    margin: 0 0 12px 0;

    span {
      margin-right: 8px;
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  width: 100%;
  padding: 0 16px;
  margin: 32px 0;

  label {
    margin: 0 0 12px 0;

    span {
      margin-right: 4px;
    }
  }
`;

export default applyStyles(SelectBoxField)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/SelectField/index.js